module.exports = __webpack_public_path__ + "img/05-Heroku.eabeee92.png";